module.exports = __webpack_public_path__ + "static/media/map.ca3a515a.png";